export default __webpack_public_path__ + "static/media/listen.f05d1494.jpg";